module.exports = __webpack_public_path__ + "img/left_top_2.7763ec7.png";